import { AbstractControl, ValidatorFn } from '@angular/forms';
import { dayjs } from '@sc/utils';

export class AppointmentEndTimeValidator {
  static consistency(
    starTimeControlName: string,
    endTimeControlName: string
  ): ValidatorFn {
    const fn = (control: AbstractControl): { [key: string]: boolean } => {
      const startTime = control.get(starTimeControlName)?.value;
      const endTime = control.get(endTimeControlName)?.value;

      if (
        startTime &&
        endTime &&
        dayjs(endTime).isSameOrBefore(dayjs(startTime))
      ) {
        return { endtime_before_starttime: true };
      }

      return null;
    };

    return fn;
  }

  static rvConsistency(rvUsePeriodControlName: string): ValidatorFn {
    const fn = (control: AbstractControl): { [key: string]: boolean } => {
      const rvUsePeriod = control.get(rvUsePeriodControlName)?.value;

      if (
        rvUsePeriod?.start &&
        rvUsePeriod?.end &&
        dayjs(rvUsePeriod?.end).isSameOrBefore(dayjs(rvUsePeriod?.start))
      ) {
        return { rv_endtime_before_starttime: true };
      }

      return null;
    };

    return fn;
  }
}
